import { buildDropboxLinksHtml } from 'util/dropbox/buildDropboxLinksHtml'

export function updateComposerIdentity(live, contextKey, draftId) {
  // Keep the shared ref object live so pending chooser callbacks see updates.
  const identity = live
  if (
    identity.contextKey !== contextKey ||
    (identity.draftId != null && identity.draftId !== draftId)
  ) {
    identity.generation += 1
  }
  identity.contextKey = contextKey
  identity.draftId = draftId
}

// Capture the originating editor and selection before the popup takes focus.
export function openDropboxChooser({
  sdk,
  editor,
  bookmark: capturedBookmark,
  isCurrent,
  onChange,
  notify,
  onStale = () => {},
}) {
  if (!editor || editor.removed || !editor.getBody()) return
  let bookmark = capturedBookmark
  if (bookmark === undefined) {
    try {
      bookmark = editor.selection.getBookmark(2, true)
    } catch (e) {
      bookmark = null
    }
  }
  let finished = false
  sdk.choose({
    linkType: 'preview',
    multiselect: true,
    folderselect: false,
    cancel: () => {
      finished = true
    },
    success: files => {
      if (finished) return
      finished = true
      if (!isCurrent() || editor.removed || !editor.getBody()) {
        onStale()
        return
      }
      try {
        const { html, skippedCount } = buildDropboxLinksHtml(files)
        if (html) {
          const oldBody = editor.getContent()
          editor.undoManager.transact(() => {
            editor.focus()
            try {
              if (!bookmark) throw new Error('No selection')
              editor.selection.moveToBookmark(bookmark)
            } catch (e) {
              editor.selection.select(editor.getBody(), true)
              editor.selection.collapse(false)
            }
            editor.insertContent(html)
          })
          onChange(editor.getContent(), oldBody)
        }
        if (skippedCount) {
          notify(
            'Some Dropbox files could not be inserted. Please choose shared file links.'
          )
        }
      } catch (e) {
        notify('Could not insert Dropbox links. Please try again.')
      }
    },
  })
}
